import React from 'react';
import BrandDetailOrderBalanceCount from '../BrandDetailOrderBalanceCount';
import { useBrandDetailOrderBalance } from '../../../../../hooks/brand/detail/useBrandDetailOrderBalance';
import BrandDetailOrderBalanceCalculate from '../BrandDetailOrderBalanceCalculate';

const BrandDetailOrderBalanceSection = ({ storeId }) => {
  const { orderSummaryInfo } = useBrandDetailOrderBalance(storeId);

  return (
    <div className="brand-detail-order-balance-section">
      {/*주문 정보*/}
      <BrandDetailOrderBalanceCount countInfo={orderSummaryInfo} />

      {/*정산 정보*/}
      <BrandDetailOrderBalanceCalculate brandId={storeId} />
    </div>
  );
};

export default BrandDetailOrderBalanceSection;
